import { useNavigate } from 'react-router-dom';
import BackButton from './BackButton';
import './ForkPage.css';
import RocketDock from './img/rocket-dock.png';
import PilotAcademy from './img/pilot-academy.png';
import ConferenceHall from './img/conference-hall.png';
import Cargo from './img/cargo.png';
import Bank from './img/bank.png';
import CommStation from './img/comm-station.png';
import CorpHQ from './img/corp-hq.png';
import LaunchBay from './img/launch-bay.png';
import WalletButton from './WalletButton';

const images = [
  RocketDock, PilotAcademy, ConferenceHall, Cargo, Bank, CommStation, CorpHQ
];
 const buttonConfigs = [
    { label: '1', color: '#ff4d4f' },
    { label: '2', color: '#ffa940' },
    { label: '3', color: '#ffc53d' },
    { label: '4', color: '#73d13d' },
    { label: '5', color: '#40a9ff' },
    { label: '6', color: '#9254de' }
  ];

const ForkPage = () => {
  const navigate = useNavigate();
  const handleWalletClick = () => {
    navigate('/wallet');
  };
  const handleWalletClick1 = () => {
    navigate('/wallet1');
  };
  return (
      
    <div className="fork-bg">
      {/* Верхняя панель с 6 разноцветными кнопками */}
      <div style={{
        position: 'fixed',
        top: 16,
        right: 16,
        display: 'flex',
        gap: 12,
        zIndex: 10
      }}>
        {buttonConfigs.map((btn, idx) => (
          <WalletButton 
            key={idx} 
            label={btn.label} 
            color={btn.color} 
            onClick={idx < 2 ? handleWalletClick : handleWalletClick1} 
          />
        ))}
    </div>
      <div className="fork-grid">
        {images.map((img, idx) => (
          <button key={idx} className="fork-item" onClick={() => navigate(`/item/${idx+1}`)}>
            <img src={img} alt={`Image ${idx+1}`} />
          </button>
        ))}
      </div>
      <div className="fork-footer">
          <button className="fork-item fork-item-footer" onClick={() => navigate('/video')}>
            <img src={LaunchBay} alt='Image 8' />
          </button>
      </div>
      <BackButton onClick={() => navigate(-1)} />

    </div>
  );
};

export default ForkPage;